import { render } from "./WordListFilters.vue?vue&type=template&id=35a1b32a&ts=true"
import script from "./WordListFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordListFilters.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/word/components/WordListFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35a1b32a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35a1b32a', __exports__)) {
    api.reload('35a1b32a', __exports__)
  }
  
  module.hot.accept("./WordListFilters.vue?vue&type=template&id=35a1b32a&ts=true", () => {
    api.rerender('35a1b32a', render)
  })

}


export default __exports__